function toggleRow(row, toggle) {
    // Expand/Collapse the row
    if (toggle == "expand") {
        row.treeExpand();   
    } else if (toggle == "collapse") {
        row.treeCollapse(); 
    } else {
        throw new Error("Wrong argument!");
    }
    
    // Get children of the row
    var children = row.getTreeChildren();

    // Recursively expand/collapse each child
    children.forEach((child) => {
        toggleRow(child, toggle)
    });
}

function toggleNestedTree(tree, toggle) {
    var rows = tree.getRows();

    // Start expanding/collapsing from the root rows
    rows.forEach((row) => {
        toggleRow(row, toggle)
    });
}

export { toggleNestedTree as default }